import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONES]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/:geoZoneId/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_POPUP]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/:geoZoneId/popup/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_PREVIEW]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/:geoZoneId/preview/',
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].CREATE_LOGISTIC_ROUTES_GEO_ZONE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PUT_LOGISTIC_ROUTES_GEO_ZONE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/:geoZoneId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PATCH_LOGISTIC_ROUTES_GEO_ZONE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/:geoZoneId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].DELETE_LOGISTIC_ROUTES_GEO_ZONE]: {
		url: '/company/:companyId/logistic_routes/:logisticRouteId/geo_zones/:geoZoneId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
